const namespace = {
  filters: {
    navigation: {
      scrollLeftAriaLabel: "Défiler vers la gauche",
      scrollRightAriaLabel: "Défiler vers la droite",
      allFiltersAriaLabel: "Voir tous les filtres",
    },
    radius: {
      title: "Rayon :",
      value: "{{value}} {{unit}}",
    },
    popup: {
      title: "Filtres",
      description: "Veuillez sélectionner une option",
      cta: {
        reset: "Réinitialiser tout",
        apply: "Appliquer le filtre",
      },
    },
    categories: {
      schools: "Écoles",
      restaurants: "Restaurants",
      groceries: "Épiceries",
      shopping: "Magasinage",
      nightlife: "Vie nocturne",
      cafes: "Cafés",
      daycares: "Garderies",
      busStops: "Arrêts d'autobus",
      metroStations: "Stations de métro",
      trainStations: "Gares",
      parks: "Parcs",
      fitness: "Conditionnement physique",
      medical: "Soins médicaux",
      petCare: "Soins aux animaux de compagnie",
      fuelStations: "Stations-service",
      activities: "Activités",
      homeImprovement: "Amélioration de l'habitat",
      personalCare: "Soins personnels",
    },
  },
} as const;

export default namespace;
